import React from 'react'

import _ from 'lodash'

import {H3, H5, Row, Card} from '../../../../components/UI/index.js'
import EmailPreview from '../../../../components/settings/EmailPreview.js'
import {formSpacing, FormStack, Input, Editor} from '../../../../components/UI/forms/index.js'

import customerWelcomeTemplate from '../../../../../server/functions/mail/templates/customerWelcomeTemplate.js'

class CustomerSettings extends React.Component {
    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.value)

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller, path)
    }

    render() {
        const {reseller} = this.props

        return (
            <Row style={{gap: 24}}>
                <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                    <H3 style={{marginBottom: 36}}>Klanten</H3>

                    <H5 style={{marginBottom: 24}}>Welkomstmail</H5>

                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Afzender naam'
                            placeholder={reseller.settings?.accountName || reseller.name}
                            value={reseller.settings.customers.senderName}
                            onChange={this.onChangeValue.bind(this, 'customers.senderName')}
                            onBlur={this.onSaveValue.bind(this, 'customers.senderName')}
                        />

                        <Input
                            label='Afzender emailadres'
                            placeholder={reseller.settings.companyAddress.email || (reseller.settings.useOwnSMTP && reseller.settings.smtpUser) || 'noreply@veloyd.nl'}
                            value={reseller.settings.customers.replyToEmail}
                            onChange={this.onChangeValue.bind(this, 'customers.replyToEmail')}
                            onBlur={this.onSaveValue.bind(this, 'customers.replyToEmail')}
                        />
                    </FormStack>

                    <br />
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Onderwerp'
                            value={reseller.settings.customers.welcomeEmailSubject}
                            onChange={this.onChangeValue.bind(this, 'customers.welcomeEmailSubject')}
                            onBlur={this.onSaveValue.bind(this, 'customers.welcomeEmailSubject')}
                        />

                        <Editor
                            label='bericht'
                            tags={['bedrijfsnaam', 'klant']}
                            value={reseller.settings.customers.welcomeEmailBody}
                            onChange={this.onSaveValue.bind(this, 'customers.welcomeEmailBody')}
                        />
                    </FormStack>
                </Card>

                <div style={{width: 650}}>
                    <EmailPreview
                        type='customerWelcome'
                        html={customerWelcomeTemplate({
                            logo: reseller.settings.logo || '/images/logoPlaceholder.png',
                            color: reseller.settings.color,
                            message: reseller.settings.customers.welcomeEmailBody?.replace(/\n/g, '<br/>') || '',
                            token: ''
                        }, window.location.origin)}
                    />
                </div>
            </Row>
        )
    }
}

export default CustomerSettings
